import {
  shape,
  string,
  arrayOf,
  number,
} from 'prop-types';

export const scoreCardType = shape({
  id: number.isRequired,
  name: string.isRequired,
  filename: string.isRequired,
});

export const scoreCardTypes = arrayOf(scoreCardType);


// WEBPACK FOOTER //
// ./src/prop-types/scoreCardTypes.js